import { Form, Input, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface VersionInfoType {
  name: string;
  description?: string;
}

export interface VersionInfoModalProps {
  open: boolean;
  onConfirm: (info: VersionInfoType) => void;
  onClose: () => void;
}

const VersionInfoModal = ({
  open,
  onClose,
  onConfirm,
}: VersionInfoModalProps) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleOk = () => {
    onConfirm({
      name,
      description,
    });
  };

  useEffect(() => {
    setName(open ? `Version - ${new Date().toISOString()}` : '');
    setDescription('');
  }, [open]);

  return (
    <Modal
      open={open}
      title={t('version_info')}
      onCancel={onClose}
      onClose={onClose}
      onOk={handleOk}
    >
      <Form layout="vertical">
        <Form.Item label={t('version_name')}>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t('input_version_name')}
            allowClear
          />
        </Form.Item>
        <Form.Item label={t('description')}>
          <Input.TextArea
            value={description}
            placeholder={t('input_description')}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default VersionInfoModal;
